import React, { useContext, useState, useEffect, useCallback } from "react";
import { Droppable } from "react-beautiful-dnd";
import VariableContext from "../contexts/VariableContext";
import FetchingFreq from "../contexts/FetchingFreq";
import config from "../configs/config";
import "./styles/Data.css";
import TabComp from "./TabComp";
import HoverDropdown from "./HoverDropdown";
import { FaPlus } from "react-icons/fa";


function Data() {
    const {
        dataGroup,
        setdataGroup,
        selectedVariables,
        banners,
        setBanners,
        setSelectedVariables,
        projectId,
        savedWeightings,
        saveCurrentWeighting,
        currentSelectedVariablesset,
        setcurrentSelectedVariablesset,
        setSavedWeightings,
        weightedCounts,
        weightingStats,
        setWeightingStats,
        setWeightedCounts,
        targetPercentages,
        setTargetPercentages,
        currentSelectedVariables,
        setCurrentSelectedVariables,
        frequencyData,
        setFrequencyData,
        setSelectedClient,
        setSelectedProject,
        selectedProject,
        selectedClient,
        powner,
        registerDndHandler,
    } = useContext(VariableContext);

    const {
        setMessage,
        setActivePage,
        handleTitleClick,
        selectedTitle,
        setSelectedTitle,
        refreshData,
        setRefreshData,
        selectedBanner,
        setselectedBanner,
        selectedWeights,
        setSelectedWeights,
        selectedVariable,
        setSelectedVariable,
        isPropertiesShow,
        setIsPropertiesShow,
        handleSelectionChange, tempBanner,
        setSelectedBannerIndex, crosstabResults, setCrosstabResults, saveCrosstabAsBanner,
    } = useContext(FetchingFreq);

    const [rowItems, setRowItems] = useState([]);
    const [columnItems, setColumnItems] = useState([]);
    const [crosstabData, setCrosstabData] = useState(null);

    const [nestTarget, setNestTarget] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [selectedCrosstabIndex, setSelectedCrosstabIndex] = useState(0);
    const [columnsInBanner, setColumnsInBanner] = useState([]); // Track which columns are in banner

useEffect(() => {
    setActivePage("crosstab");
  }, []);
    const handleTabChange = (tabName) => {
        if (!tabName) {
            setselectedBanner(null);
            return;
        }

        const banner = banners.find(b => b.name === tabName);
        if (banner) {
            setselectedBanner(banner);
        }
    };
    const handleAddToBanner = () => {
        const currentCrosstab = crosstabResults?.[selectedCrosstabIndex];
        if (!currentCrosstab) return;

        handleSelectionChange("__CROSSTAB__", currentCrosstab, true, null);

        // auto select newly added banner
        setTimeout(() => {
            if (banners.length > 0) {
                const last = banners[banners.length - 1];
                setselectedBanner(last);
                setSelectedBannerIndex(banners.length - 1);
            }
        }, 0);
    };
    const canAddToBanner = columnItems.length > 0 && rowItems.length > 0;




    // Resolve a human friendly label for a code using the provided value-label map
    const getLabelFromValueLabels = (valueKey, labels) => {
        if (!labels) return null;
        const normalizedKey = String(valueKey);
        // Try exact match, then a ".0" suffixed numeric key (common in SPSS exports)
        if (labels[normalizedKey]) return labels[normalizedKey];
        if (labels[`${normalizedKey}.0`]) return labels[`${normalizedKey}.0`];
        return null;
    };

    // Decide what text to show when listing selected variables
    const getDisplayName = (item) => item?.id;

    // Register handler for App.js to call (via Context)
    useEffect(() => {
        registerDndHandler("data", handleDragEnd);
        return () => {
            registerDndHandler("data", null);
        };
    }, [dataGroup, rowItems, columnItems, nestTarget, registerDndHandler]);

    // Handle drag end from sidebar
    const handleDragEnd = (result) => {
        const { source, destination } = result;
        if (!destination) {
            setNestTarget(null);
            return;
        }

        // Only handle drags from sidebar to Data component
        if (
            source.droppableId === "sidebar-questions" &&
            (destination.droppableId === "rows" ||
                destination.droppableId === "columns")
        ) {
            if (!dataGroup) return;

            const [key, value] = Object.entries(dataGroup)
                .find(([key, g]) => g?.order === source.index);

            const isSameDropzone =
                nestTarget?.droppableId &&
                nestTarget?.droppableId === destination.droppableId;

            const draggedItem = {
                id: key,
                selectedVariable: value,
                parentId: isSameDropzone ? nestTarget?.itemId || null : null,
            };

            // Add to rows
            if (destination.droppableId === "rows") {
                if (!rowItems.find((item) => item.id === draggedItem.id)) {
                    setRowItems((prev) => [...prev, draggedItem]);
                }
            }
            // Add to columns
            else if (destination.droppableId === "columns") {
                if (!columnItems.find((item) => item.id === draggedItem.id)) {
                    setColumnItems((prev) => [...prev, draggedItem]);
                    // When adding to columns, mark it as not in banner by default
                    setColumnsInBanner((prev) => [...prev, { id: draggedItem.id, inBanner: false }]);
                    handleSelectionChange(draggedItem.id, draggedItem.selectedVariable, false, draggedItem.parentId); // Avoid saving to banner here
                }
            }
        }

        setNestTarget(null);
        setCrosstabResults([]); // Clear previous crosstabs when items change
        setError(null);
        setSelectedCrosstabIndex(0);
    };

    const removeRow = (itemId) => {
        setRowItems((prev) => {
            const newItems = prev.filter((item) => item.id !== itemId);
            // Also remove children of this item
            return newItems.filter((item) => item.parentId !== itemId);
        });
        setCrosstabResults([]);
        setError(null);
        setSelectedCrosstabIndex(0);
    };

    const removeColumn = (itemId) => {
        setColumnItems((prev) => {
            const newItems = prev.filter((item) => item.id !== itemId);
            // Also remove children of this item
            return newItems.filter((item) => item.parentId !== itemId);
        });
        // Also remove from columnsInBanner tracking
        setColumnsInBanner((prev) => prev.filter(col => col.id !== itemId));
        setCrosstabResults([]);
        setError(null);
        setSelectedCrosstabIndex(0);
    };

    const toggleColumnInBanner = (itemId) => {
        setColumnsInBanner(prev =>
            prev.map(col =>
                col.id === itemId
                    ? { ...col, inBanner: !col.inBanner }
                    : col
            )
        );
    };

    const handleMouseMove = (e, itemId, droppableId) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const y = e.clientY - rect.top;
        const height = rect.height;

        // Nest if in bottom 40% of item
        if (y > height * 0.6) {
            setNestTarget({ itemId, droppableId });
        } else {
            setNestTarget(null);
        }
    };

    const handleMouseLeave = () => {
        setNestTarget(null);
    };

    // Add column to banner using the existing handleSelectionChange function
    const addColumnToBanner = (itemId) => {
        const columnItem = columnItems.find(item => item.id === itemId);
        if (columnItem) {
            handleSelectionChange(columnItem.id, columnItem.selectedVariable);
            // Update tracking
            toggleColumnInBanner(itemId);
        }
    };

    // Generate cross-tabs for all row variables
    const generateCrosstabs = async () => {
        if (rowItems.length === 0 || columnItems.length === 0) {
            setError("Please add at least one variable to both Rows and Columns");
            return;
        }

        setIsLoading(true);
        setError(null);

        try {
            const results = [];

            // For each row variable, generate cross-tab with all column variables
            for (const rowItem of rowItems) {
                handleTitleClick(rowItem.id);

                results.push({
                    rowVariable: rowItem.id,
                    rowData: rowItem.selectedVariable,
                    crosstabData: frequencyData,
                });
            }


            if (results.length > 0) {
                setSelectedCrosstabIndex(0);
            }

        } catch (err) {
            setError(`Error generating cross-tabs: ${err.message}`);
            console.error("Crosstab error:", err);
        } finally {
            setIsLoading(false);
        }
    };

    // Render items in dropzones with proper hierarchy
    const renderRowItems = () => {
        const parents = rowItems.filter((item) => !item.parentId);
        const children = rowItems.filter((item) => item.parentId);

        const result = [];

        parents.forEach((parent) => {
            result.push(
                <div
                    key={parent.id}
                    className={`variable-row ${nestTarget?.itemId === parent.id &&
                        nestTarget?.droppableId === "rows"
                        ? "nest-hover"
                        : ""
                        }`}
                    onMouseMove={(e) => handleMouseMove(e, parent.id, "rows")}
                    onMouseLeave={handleMouseLeave}
                >
                    <span className="variable-name">{getDisplayName(parent)}</span>
                    <button
                        className="remove-x"
                        onClick={() => removeRow(parent.id)}
                        title="Remove variable"
                    >
                        ×
                    </button>
                </div>
            );

            // Add children of this parent
            children.forEach((child) => {
                if (child.parentId === parent.id) {
                    result.push(
                        <div
                            key={child.id}
                            className="variable-row nested"
                            onMouseMove={(e) => handleMouseMove(e, child.id, "rows")}
                            onMouseLeave={handleMouseLeave}
                        >
                            <span className="variable-name">
                                <span className="nest-indicator">└─ </span>
                                {getDisplayName(child)}
                            </span>
                            <button
                                className="remove-x"
                                onClick={() => removeRow(child.id)}
                                title="Remove variable"
                            >
                                ×
                            </button>
                        </div>
                    );
                }
            });
        });

        // Add orphaned children
        const orphans = children.filter(
            (child) => !parents.find((p) => p.id === child.parentId)
        );
        orphans.forEach((orphan) => {
            result.push(
                <div
                    key={orphan.id}
                    className="variable-row"
                    onMouseMove={(e) => handleMouseMove(e, orphan.id, "rows")}
                    onMouseLeave={handleMouseLeave}
                >
                    <span className="variable-name">{getDisplayName(orphan)}</span>
                    <button
                        className="remove-x"
                        onClick={() => removeRow(orphan.id)}
                        title="Remove variable"
                    >
                        ×
                    </button>
                </div>
            );
        });

        return result;
    };

    const renderColumnItems = () => {
        const parents = columnItems.filter((item) => !item.parentId);
        const children = columnItems.filter((item) => item.parentId);

        const result = [];

        parents.forEach((parent) => {
            const isInBanner = columnsInBanner.find(col => col.id === parent.id)?.inBanner || false;

            result.push(
                <div
                    key={parent.id}
                    className={`variable-row ${nestTarget?.itemId === parent.id &&
                        nestTarget?.droppableId === "columns"
                        ? "nest-hover"
                        : ""
                        }`}
                    onMouseMove={(e) => handleMouseMove(e, parent.id, "columns")}
                    onMouseLeave={handleMouseLeave}
                >
                    <span className="variable-name">{getDisplayName(parent)}</span>
                    <div className="column-actions">
                        <button
                            className="remove-x"
                            onClick={() => removeColumn(parent.id)}
                            title="Remove variable"
                        >
                            ×
                        </button>
                    </div>
                </div>
            );

            // Add children of this parent
            children.forEach((child) => {
                if (child.parentId === parent.id) {
                    const isChildInBanner = columnsInBanner.find(col => col.id === child.id)?.inBanner || false;

                    result.push(
                        <div
                            key={child.id}
                            className="variable-row nested"
                            onMouseMove={(e) => handleMouseMove(e, child.id, "columns")}
                            onMouseLeave={handleMouseLeave}
                        >
                            <span className="variable-name">
                                <span className="nest-indicator">└─ </span>
                                {getDisplayName(child)}
                            </span>
                            <div className="column-actions">
                                <button
                                    className="remove-x"
                                    onClick={() => removeColumn(child.id)}
                                    title="Remove variable"
                                >
                                    ×
                                </button>
                            </div>
                        </div>
                    );
                }
            });
        });

        // Add orphaned children
        const orphans = children.filter(
            (child) => !parents.find((p) => p.id === child.parentId)
        );
        orphans.forEach((orphan) => {
            const isOrphanInBanner = columnsInBanner.find(col => col.id === orphan.id)?.inBanner || false;

            result.push(
                <div
                    key={orphan.id}
                    className="variable-row"
                    onMouseMove={(e) => handleMouseMove(e, orphan.id, "columns")}
                    onMouseLeave={handleMouseLeave}
                >
                    <span className="variable-name">{getDisplayName(orphan)}</span>
                    <div className="column-actions">
                        <button
                            className="remove-x"
                            onClick={() => removeColumn(orphan.id)}
                            title="Remove variable"
                        >
                            ×
                        </button>
                    </div>
                </div>
            );
        });

        return result;
    };

    // Render cross-tab results
    const renderCrosstabResults = () => {
        return (
            <>
                {/* SELECT BANNER */}
                {/* Add to Banner – only when row & column both exist */}
                {/* Add to Banner UI – ONLY after Generate Crosstab */}
                {canAddToBanner && (
                    <div
                        style={{
                            display: "flex",
                            gap: "8px",
                            alignItems: "center",
                            marginBottom: "12px",
                        }}
                    >
                        {/* Show Select Banner ONLY if banners exist */}
                        {banners.length > 0 && (
                            <HoverDropdown
                                text={selectedBanner?.name || "Select Banner"}
                                exportfeatures={banners}
                                handleTabChange={handleTabChange}
                                feature={2}
                            />
                        )}

                        <button
                            className="add-banner-btn"
                            onClick={handleAddToBanner}
                            title="Add Crosstab to Banner"
                        >
                            Add to Banner <FaPlus />
                        </button>
                    </div>
                )}

                {/* EMPTY STATE */}
                {crosstabResults.length === 0 ? (
                    <div style={{ display: "flex" }}>
                        <div className="no-crosstab-message">
                            <p>
                                No cross-tabs generated yet. Add variables to Rows and Columns,
                                then click Generate Crosstab.
                            </p>
                        </div>
                    </div>
                ) : (
                    <div className="crosstab-results-container">
                        {/* Tab navigation for multiple cross-tabs */}
                        <div className="crosstab-tabs">
                            {crosstabResults.map((result, index) => (
                                <button
                                    key={index}
                                    className={`crosstab-tab ${selectedCrosstabIndex === index ? "active" : ""
                                        }`}
                                    onClick={() => setSelectedCrosstabIndex(index)}
                                >
                                    {index}
                                </button>
                            ))}
                        </div>

                        {/* Display selected cross-tab */}
                        {crosstabResults[selectedCrosstabIndex] && (
                            <div className="crosstab-result">
                                <div className="crosstab-header">
                                    <h3>
                                        {crosstabResults[selectedCrosstabIndex].rowVariable}
                                        <span className="vs-text"> vs </span>
                                        {columnItems.map(col => col.id).join(", ")}
                                    </h3>
                                    <div className="banner-status">
                                        <small>
                                            Columns in banner:{" "}
                                            {columnsInBanner.filter(col => col.inBanner).length}
                                            {" "}of {columnItems.length}
                                        </small>
                                    </div>
                                </div>

                                <TabComp
                                    isCrossTab={false}
                                    frequencyData={crosstabResults[selectedCrosstabIndex]}
                                    displayMode="table"
                                    displaySettings={{
                                        showFrequency: true,
                                        showPercent: true
                                    }}
                                />
                            </div>
                        )}
                    </div>
                )}
            </>
        );
    };


    return (
        <div className="data-container">
            {/* Left Panel with Button and Dropzones */}
            <div className="data-left-panel">
                <button
                    className={`generate-crosstab-btn ${rowItems.length === 0 || columnItems.length === 0 ? "disabled" : ""
                        }`}
                    onClick={generateCrosstabs}
                    disabled={
                        rowItems.length === 0 || columnItems.length === 0 || isLoading
                    }
                >
                    {isLoading ? (
                        "Generating..."
                    ) : (
                        <>
                            Generate
                            <br />
                            Crosstab
                        </>
                    )}
                </button>

                <Droppable droppableId="columns">
                    {(provided, snapshot) => (
                        <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            className={`columns-dropzone ${snapshot.isDraggingOver ? "drag-over" : ""
                                }`}
                        >
                            <div className="dropzone-header columns-header-bg">
                                <span>COLUMNS</span>
                                <small className="banner-hint">Click + to add to banner</small>
                            </div>
                            <div className="dropzone-body">
                                {columnItems.length === 0 ? (
                                    <div className="empty-dropzone">Drag variables here</div>
                                ) : (
                                    renderColumnItems()
                                )}
                            </div>
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>

                <Droppable droppableId="rows">
                    {(provided, snapshot) => (
                        <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            className={`rows-dropzone ${snapshot.isDraggingOver ? "drag-over" : ""
                                }`}
                        >
                            <div className="dropzone-header rows-header-bg">
                                <span>ROWS</span>
                                <small className="banner-hint">One table per variable</small>
                            </div>
                            <div className="dropzone-body">
                                {rowItems.length === 0 ? (
                                    <div className="empty-dropzone">Drag variables here</div>
                                ) : (
                                    renderRowItems()
                                )}
                            </div>
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </div>

            {/* Right Panel with Table */}
            <div className="data-right-panel">
                {error && (
                    <div className="error-message">
                        {error}
                    </div>
                )}

                {isLoading ? (
                    <div className="loading-indicator">
                        <div className="spinner"></div>
                        <p>Generating cross-tabs...</p>
                    </div>
                ) : (
                    renderCrosstabResults()
                )}
            </div>

        </div>
    );
}

export default Data;